export const pathname = '/entry/form';

export const filepathname = '/entry';